import * as React from 'react';
import { clsx } from 'clsx';

import * as style from './Transition.css';

export const Transition = ({ children }: React.PropsWithChildren): React.JSX.Element => {
  const [isShown, setIsShown] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => setIsShown(true));
  });

  return <div className={clsx(style['block'], { [style['block-shown']]: isShown })}>{children}</div>;
};
